<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_title"><a id="page_iii"></a><strong>SPARK <span class="small">FROM THE</span> DEEP</strong></h1>
<p class="subtitle"><em>How Shocking Experiments with<br/>Strongly Electric Fish Powered Scientific Discovery</em></p>
<p class="author">WILLIAM J. TURKEL</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?633e36f2